/**
 * @file 用户user 模块接口列表
 * @version
 * @author pankzou
 * @date 2021-10-08
 * @lastModified
 * @lastModifiedDate
 */

import { post, postQuery } from "../http"

export default {
    // md5加密
    findDgsLicList(data) {
        return post('/iframework/yDgsLic/findDgsLicList', data)
    },
    // 查询
    licmaininfo(data, headers) {
        return postQuery('/scjgyzt-public/dataapi/demo/dev/C_ZH/licmaininfo', data, { ...headers })
    },
    // 查询
    bjspAllNum(data, headers) {
        return postQuery('/scjgyzt-public/dataapi/demo/dev/C_ZH/LIC_MAIN_INFO_GGSP_NUM', data, { ...headers })
    },
    // 按需查询
    licmaininfobyparam(data, headers) {
        return postQuery('/scjgyzt-public/dataapi/demo/dev/C_ZH/licmaininfobyparam', data, { ...headers })
    },
    licmaininfobygy(data, headers) {
        return postQuery('/scjgyzt-public/dataapi/demo/dev/C_ZH/licmaininfobygy', data, { ...headers })
    },
    licmaininfobygyparam(data, headers) {
        return postQuery('/scjgyzt-public/dataapi/demo/dev/C_ZH/licmaininfobygyparam', data, { ...headers })
    },
    // 查询广告的详情
    ggspXzspFile(data, headers) {
        return postQuery('/scjgyzt-public/dataapi/demo/dev/C_ZH/LIC_MAIN_INFO_GGSP_TS_FILE', data, { ...headers })
    },
    // 广告审查全量查看
    ggspFullQuery(data, headers) {
        return postQuery('/scjgyzt-public/dataapi/demo/dev/C_ZH/LIC_MAIN_INFO_GGSP_CS', data, { ...headers })
    },
    // 广告审查条件查询
    ggspConditionalQuery(data, headers) {
        return postQuery('/scjgyzt-public/dataapi/demo/dev/C_ZH/LIC_MAIN_INFO_GGSP_TS', data, { ...headers })
    }
}
